<template>
  <section
    class="relative"
  >
    <div
      class="absolute inset-0 top-1/2 from-black to-transparent bg-gradient-to-t"
    />
    <div
      class="text-white tracking-tight absolute bottom-0 inset-x-0 p-6 xl:p-10 pb-6 xl:pb-16"
    >
      <div
        class="tracking-tight width-lg xl:mx-auto"
      >
        <div
          class="flex items-center gap-14"
        >
          <div
            class="flex-shrink uppercase text-3xl xl:text-6xl"
          >
            {{ formattedPrice }}
          </div>
        </div>
      </div>
    </div>
    <div
      class="absolute inset-x-0 top-0 bg-black bg-opacity-40 xl:hidden"
      :class="{ 'bg-opacity-90' : isMenuOpen }"
    >
      <div
        class="text-white text-xl tracking-tight font-book flex flex-row justify-between items-center"
      >
        <h1
          class="py-3 pl-5"
        />
        <div
          class="px-5 py-3"
          @click="isMenuOpen = !isMenuOpen"
        >
          <font-awesome-icon
            :icon="isMenuOpen ? 'times' : 'bars'"
          />
        </div>
      </div>
      <div
        class="menu text-white right-0 text-right text-gray-300"
        :class="{ hidden: !isMenuOpen }"
      >
        <ul>
          <MenuItems
            :items="menuItems"
          />
        </ul>
      </div>
    </div>
    <img
      v-if="primaryPhoto"
      :alt="primaryPhoto.short_description || 'Missing photo description'"
      class="w-full object-cover h-96 xl:h-homepic"
      :src="primaryPhoto.media_url"
    >
    <div
      v-else
      class="bg-gray-700 h-96"
    />
  </section>
</template>

<script>
import { faBars } from '@fortawesome/free-solid-svg-icons/faBars';
import { faTimes } from '@fortawesome/free-solid-svg-icons/faTimes';
import { isEmptyString } from 'mytribus-commons';
import { library } from '@fortawesome/fontawesome-svg-core';

import getPropertyPhotos from '../helpers/getPropertyPhotos';
import MenuItems from '../components/MenuItems.vue';

export default {
  name: 'PropertyHome',

  components: {
    MenuItems,
  },

  props: {
    menuItems: {
      required: true,
      type: Object,
    },
    property: {
      required: true,
      type: Object,
    },
  },

  data() {
    return {
      isMenuOpen: false,
    };
  },

  computed: {
    /** @type {string} */
    formattedPrice() {
      const { property = {} } = this;
      const { listing = {} } = property;
      const { price = {} } = listing;

      const {
        close_price: closePrice = null,
        list_price: listPrice = null,
      } = price;

      const [shownPrice] = [closePrice, listPrice]
        .map((p) => parseInt(p, 10)).filter((p) => p);

      if (!shownPrice) {
        return 'No Price';
      }

      return `$${shownPrice.toLocaleString()}`;
    },

    /** @type {object|undefined} */
    primaryPhoto() {
      return getPropertyPhotos(this.property)
        .find((photo) => photo);
    },
  },

  created() {
    library.add(faBars);
    library.add(faTimes);
  },

  methods: {
    /** @return {boolean} */
    isEmptyString,
  },
};
</script>

<style lang="scss">
.menu {
  padding-bottom: 20px;

  a {
    display: block;
    font-weight: 600;
    transition: padding-right 0.1s ease-out;
    padding: 10px 19px;

    &:hover {
      color: white;
      padding-right: 25px;
    }
  }
}
</style>
